export const CLIENT_CONTACTS = {
  email: "danil207tim@gmail.com",
  telegram: "@kfmkfm",
};

export const CLIENT_PAYMENT_WALLETS = {
  usdt_arbitrum: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
  usdt_avax: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
  usdt_bsc: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
  usdt_eth: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
  usdt_polygon: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
  usdt_sol: "2wnxZsQRGDyAq6CFFSY1ZksJhh1CNyVXTpfZG8vxw8CD",
  usdt_ton: "UQB3EPqbLjx-lb5DgAJM8w0d77oOwdMFK9g4T37QL_kkYdOM",
  usdt_tron: "TFzTspykCEP6S2muxrJXBn7k67KJSiLbho",

  avax: "X-avax1lm3n035nw8t2kh34tgl99fgspkp8l9zzy5t7a8",
  bch: "1GpKtECTA8mZWuuHxUEiQRj4TUPQDC7wki",
  bnb: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
  btc: "bc1qesyggn6apn8rpgeeqsfqc3trcqyfcay0yxev7z",
  dash: "Xwvk1BvQ6NpTEjQrDM2SBPAx4KDLgZPGBW",
  doge: "D6gjnEFQMukouAh36hUUztwEqGMiTJbKUg",
  ltc: "ltc1qm0l3ktx3y0f7mfye0gwf5k28j6yhv5a03lpefs",
  sol: "2wnxZsQRGDyAq6CFFSY1ZksJhh1CNyVXTpfZG8vxw8CD",
  ton: "UQB3EPqbLjx-lb5DgAJM8w0d77oOwdMFK9g4T37QL_kkYdOM",
  trx: "TFzTspykCEP6S2muxrJXBn7k67KJSiLbho",
  xmr: "82hieJA29kB6yuNxs2KAYC5TFyfSR2LPBW4b7rAesWqQK5QGjfs4pJCf7zm7DeJAGPJDNMuXatS4BV5m9cAD5BoHRDNcmTg",

  usdc_arbitrum: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
  usdc_bsc: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
  usdc_eth: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",

  dai_eth: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",

  eth_eth: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
  eth_bsc: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
  eth_arbitrum: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",

  matic_eth: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
  shib_eth: "0xD25c141E5910c8A8f96E996f5b30311B16c1295A",
};